import "slick-carousel";
import "slick-carousel/slick/slick.css";

$(document).ready(function () {
  // Initialiser le slider
  $(".services_carousel_services").slick({
    infinite: false,
    slidesToShow: 1, // Ajustez ce nombre en fonction de vos besoins initiaux
    slidesToScroll:1,
    arrows: false,
    dots: true,
    mobileFirst: true,
    customPaging: function (slider, i) {
        return '<span class="slick-bullet"></span>';
    },
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll:1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll:2,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
          slidesToScroll:2,
        },
      },
      {
        breakpoint: 1800,
        settings: {
          slidesToShow: 3,
          slidesToScroll:3,
        },
      },
      
    ],
  });

  // Fonction pour vérifier si un élément est entièrement visible dans le viewport
  function isElementFullyVisible(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.left >= 0 &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  // Gestion de la classe 'slick-active' pour les éléments entièrement visibles
  function setActiveSlides() {
    $(".garages_gal .slick-slide").each(function () {
      const $slide = $(this);
      if (isElementFullyVisible(this)) {
        $slide.addClass("slick-visible");
      } else {
        $slide.removeClass("slick-visible");
      }
    });
  }

  // Appel initial et après chaque repositionnement des slides
  $(".garages_gal").on("beforeChange", function () {
    $(".garages_gal .slick-slide").removeClass("slick-visible");
  });

  $(".garages_gal").on("setPosition", function () {
    setActiveSlides();
  });

  // Appel initial pour s'assurer que tout est bien configuré dès le chargement
  setActiveSlides();
});
